import React, { useMemo, useState } from 'react';
import { IconButton, Loader } from 'rsuite';
import ReloadIcon from '@rsuite/icons/Reload';
import { cuotitasStoreService } from '../../services';

export const useInstallmentsStepSecond = (context) => {
    const [selectedValue, setSelectedValue] = useState('');
    const [loadingInstallments, setLoadingInstallments] = useState(false);
    const [amountTarget, setAmountTarget] = useState('');
    const [showFeeValues, setShowFeeValues] = useState(false);
    const [idsPlan, setIdsPlan] = useState([]);
    const [installmentsList, setInstallmentsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchInstallmentsByOffer = async (amount) => {
        setLoadingInstallments(true);
        const offer = context.offer?.id || context.formInstallments.id_loan_offer;
        try {
            const response = await cuotitasStoreService.getInstallmentsByOffer(
                context.idStore,
                offer,
                amount
            );
            localStorage.setItem('assistance', JSON.stringify(response?.assistanceMapping));
            setIdsPlan(response?.idsPlan);
            setInstallmentsList(response?.installmentsList);
        }
        catch (error) {
            console.error('Error al obtener las cuotas:', error);
        }
        finally {
            setLoadingInstallments(false);
        }
    };

    const handleAmountChange = (value) => {
        setShowFeeValues(false);
        setAmountTarget(value);
    };

    const getFeeValues = async () => {
        setIsLoading(true);
        setSelectedValue('');
        context.setFormInstallments((prev) => ({ ...prev, amount: amountTarget }));
        await fetchInstallmentsByOffer(amountTarget);
        setIsLoading(false);
        setShowFeeValues(true);
    };

    const isLessThanMin = (amount) =>
        amount < context?.amountLimit?.amountMinByPerson ||
        amount < context?.amountLimit?.amountMinOfInstallments;

    const isGreaterThanMax = (amount) =>
        amount > context?.amountLimit?.amountMaxByPerson ||
        amount > context?.amountLimit?.amountMaxOfInstallments;

    const disabledGetFeeValues = () => isLessThanMin(amountTarget) || isGreaterThanMax(amountTarget);

    const installmentAllowed = useMemo(
        () => installmentsList.filter((i) => i.idPlanName === selectedValue),
        [installmentsList, selectedValue]
    );

    return {
        selectedValue,
        setSelectedValue,
        amountTarget,
        setAmountTarget,
        idsPlan,
        installmentAllowed,
        handleAmountChange,
        showFeeValues,
        extraContent: (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    justifyContent: 'flex-start',
                    width: '100%',
                }}
            >
                <span style={{ fontWeight: 500 }}>Mostrar productos y cuotas</span>
                <IconButton
                    icon={<ReloadIcon style={{ color: 'blue' }} />}
                    disabled={context.isLoading || !amountTarget || disabledGetFeeValues()}
                    onClick={getFeeValues}
                />
                {isLoading && <Loader size="md" content="Calculando productos y cuotas..." />}
            </div>
        ),
        isLoading: isLoading || loadingInstallments,
        disabledNext: loadingInstallments,
    };
};
